import MoodStrip     from '../components/MoodStrip';
import useScrollReveal from '../hooks/useScrollReveal';

export default function MoodMascot() {
  const [ref, visible] = useScrollReveal();

  return (
    <section
      className="section"
      style={{
        background: 'linear-gradient(180deg, var(--surface) 0%, var(--bg) 100%)',
        paddingBottom: 64,
      }}
    >
      <div className="container section-content">
        <div
          ref={ref}
          className={`reveal ${visible ? 'visible' : ''}`}
          style={{ textAlign: 'center', marginBottom: 32 }}
        >
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              background: 'rgba(51,170,255,0.08)',
              border: '1px solid rgba(51,170,255,0.2)',
              borderRadius: 24,
              padding: '6px 16px',
              marginBottom: 16,
            }}
          >
            <span
              style={{
                fontWeight: 700,
                fontSize: 11,
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: 'var(--accent)',
              }}
            >
              Mood System
            </span>
          </div>
          <h2 className="section-headline" style={{ textAlign: 'center' }}>The board knows how you feel</h2>
          <p className="section-sub" style={{ maxWidth: 520, margin: '12px auto 0', textAlign: 'center' }}>
            Ripple's mascot reacts to your performance in real time — from triumphant to tense.
          </p>
        </div>
      </div>
      <MoodStrip />
    </section>
  );
}
